export interface SessionAuthoredDefinition {
  version:number;
  questions:Array<{id:string;interview_id:string;question_text:string;question_type?:string;
    expected_duration_seconds?:number|null;difficulty_level?:string;order_index?:number;is_required?:boolean}>;
}
export class SessionAuthoredDefinitionError extends Error {}
export function applySessionAuthoredDefinition<T extends {questions?:unknown[]}>(interview:T,definition?:SessionAuthoredDefinition|null):T & {questions?:unknown[];session_authored_definition?:SessionAuthoredDefinition} {
  if(definition==null)return interview;
  if(definition.version!==1 || !Array.isArray(definition.questions)
    || definition.questions.some(question=>!question || typeof question.question_text!=='string'
      || typeof question.id!=='string' || typeof question.interview_id!=='string'))throw new SessionAuthoredDefinitionError('Session question definition is invalid or unsupported.');
  return {...interview,questions:definition.questions,session_authored_definition:definition};
}
export async function resolveSessionAuthoredQuestions(details:{questions?:unknown[];session_authored_definition?:SessionAuthoredDefinition}|null|undefined,
  interviewId:string|undefined,loadLegacy:()=>Promise<{questions?:unknown[]}>):Promise<unknown[]> {
  if(details?.session_authored_definition){
    return applySessionAuthoredDefinition({},details.session_authored_definition).questions || [];
  }
  if(Array.isArray(details?.questions) && details.questions.length)return details.questions;
  if(!interviewId)return [];
  const fresh=await loadLegacy();return Array.isArray(fresh.questions) ? fresh.questions : [];
}
